import { render, staticRenderFns } from "./Yarnboard4.vue?vue&type=template&id=5e758ad6&scoped=true&"
import script from "./Yarnboard4.vue?vue&type=script&lang=js&"
export * from "./Yarnboard4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e758ad6",
  null
  
)

export default component.exports